import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { useFavicon } from '@ecp/common/src/hooks/layout/FaviconHook.js';
import skypass from '@ecp/common/src/style/theme/skypass';
import welplus from '@ecp/common/src/style/theme/welplus';
import asiana from '@ecp/common/src/style/theme/asiana';
import theme_1_0 from '@ecp/common/src/style/theme/theme_1_0';
import freet from '@ecp/common/src/style/theme/freet';
import defaultTheme from '@ecp/common/src/style/theme/default';

import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import { themeState } from '@ecp/mo/src/recoil/theme/atom';
import koreanAir from '@ecp/common/src/style/theme/koreanAir';

const SiteInformationProvider = () => {
  const { fetch, getSystemInformationByKey, systemInformation } = useSiteInfo();
  const setTheme = useSetRecoilState(themeState);
  useFavicon(systemInformation);

  useEffect(() => {
    const handleSiteInformation = async () => {
      if (!getSystemInformationByKey('siteName')) {
        const result = await fetch();

        setSiteDesc(result.siteDesc);
        setTitle(result);
        switch(result.theme) {
          case 'skypass': setTheme(skypass); break;
          case 'welplus': setTheme(welplus); break;
          case 'asiana' : setTheme(asiana); break;
          case 'theme_1_0': setTheme(theme_1_0); break;
          case 'freet': setTheme(freet); break;
          case 'koreanAir': setTheme(koreanAir); break;
          default: setTheme(defaultTheme);
        }
      }
    };

    handleSiteInformation();
  }, [fetch, getSystemInformationByKey, setTheme]);

  function setSiteDesc(siteDesc) {
    if (siteDesc) {
      const htmlContent = document.querySelector('meta[name="description"]'); // <content> 태그 찾기
      htmlContent.setAttribute('content', siteDesc);
    }
  }

  function setTitle(result) {
    const htmlTitle = document.querySelector('title'); // <title> 태그 찾기

    htmlTitle.innerText =
      result && result.isMultimall ? result.siteName : result.siteName + ' - 건강함에 새로움을 더하다.'; // <title> 태그에 변수 title값을 넣음
  }
};

export default SiteInformationProvider;
